import type { Tool, PointerSample, ToolContext } from "./Tool";

// Pans the viewport on drag. Does not produce Commands — viewport changes
// are not part of the document or history.

export class HandTool implements Tool {
  readonly id = "hand";
  readonly shortcut = "H";
  private dragStart: { sx: number; sy: number; panX: number; panY: number } | null = null;

  onPointerDown(ctx: ToolContext, s: PointerSample): void {
    this.dragStart = {
      sx: s.x,
      sy: s.y,
      panX: ctx.viewport.panX,
      panY: ctx.viewport.panY,
    };
  }

  onPointerMove(ctx: ToolContext, s: PointerSample): void {
    if (!this.dragStart) return;
    ctx.setViewport({
      panX: this.dragStart.panX + (s.x - this.dragStart.sx),
      panY: this.dragStart.panY + (s.y - this.dragStart.sy),
    });
  }

  onPointerUp(): void {
    this.dragStart = null;
  }
}
